app.controller("StudentNewIndexController", [
    "$scope", "Students", "PollService", "LecturerService", "FreshModal", "$stateParams", "AuthService", "StaticData", "$q", "StSubject",
    function ($scope, Students, PollService, LecturerService, FreshModal, $stateParams, AuthService, StaticData, $q, StSubject) {
        $scope.newPoll = null;

        function loadCurrentSubjects() {
            $q.all([StSubject.listBySemester({
                limit: $scope.itemsPerPage,
                student: $stateParams.profile
            }), StSubject.totals({student: $stateParams.profile})]).then(function (data) {
                $scope.semesterSubjects = data[0];
            });
        }

        $scope.getLast = function () {
            PollService.getLast().then(function (data) {
                $scope.newPoll = data;
                if(data.poll) {
                    $scope.text = data.poll.text;
                    $scope.answers = data.poll.answers;
                }
            });
        };

        $scope.submit = function (answer) {
            if(answer) {
                PollService.mark({
                    poll: $scope.newPoll._id,
                    state: 'answered',
                    answer: answer
                }).then(function () {
                    $scope.newPoll = null;
                    $scope.getLast();
                })
            }
        };

        $scope.getLast();
        loadCurrentSubjects();

        $scope.openSubjectDetails = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            FreshModal.open({
                controller: "StudentNewSubjectDetailsController",
                templateUrl: _pb + 'student-new/subject-details.html',
                resolve: {
                    subject: function () {
                        return subject;
                    }
                }
            }).then(function (result) {
            }, function (result) {
            });
        };

        $scope.showInfo = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            FreshModal.open({
                controller: "StudentNewSubjectInfoModalController",
                templateUrl: _pb + 'student-new/subject-info-modal.html',
                resolve: {
                    subject: function () {
                        return subject;
                    }
                }
            }).then(function (result) {
            }, function (result) {
            });
        };

        $scope.showButton = function (subject) {
            for(var i in subject.subjectSessionGroups) {
                if(subject.subjectSessionGroups[i].zoomUrl) {
                    return true;
                }
            }
        };

        $scope.showArchiveButton = function (subject) {
            for (var i in subject.subjectSessionGroups) {
                if (subject.subjectSessionGroups[i].archiveUrl) {
                    return true;
                }
            }
        };

        $scope.goToURL = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            for(var i in subject.subjectSessionGroups) {
                if(subject.subjectSessionGroups[i].zoomUrl) {
                    window.open(subject.subjectSessionGroups[i].zoomUrl)
                }
            }
        }

        $scope.goToArchiveURL = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            for(var i in subject.subjectSessionGroups) {
                if(subject.subjectSessionGroups[i].archiveUrl) {
                    window.open(subject.subjectSessionGroups[i].archiveUrl)
                }
            }
        };

        $scope.exportSyllabus = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            var name = subject.name;
            name = name.replace(/[&$%@#!?`'"|\/<>{}*+,;:^]/g, "");
            window.open(`${location.origin}/syllabuses/export/${subject._id}/${name}`);
        };

        $scope.consultations = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            subject.subjectSessionGroups.forEach(group => {
                if(group.sessionType === 'lecture') {
                    LecturerService.getConsultations([group.lecturer._id]).then(function (result) {
                        if (result) {
                            FreshModal.open({
                                controller: "StudentNewSubjectInfoModalController",
                                templateUrl: _pb + 'student-new/subject-info-modal.html',
                                resolve: {
                                    subject: {
                                        consultation: true,
                                        name: subject.name,
                                        post: result[0] ? {
                                            text: result[0].value,
                                            createDate: result[0].fromDate
                                        } : null
                                    }
                                }
                            }).then(function (result) {
                            }, function (result) {
                            });
                        }
                    });
                }
            })
        }
    }
]);
